import { z } from "zod";

import http from "@/services/http";

const answerOption = z.object({
  id: z.number().optional(),
  value: z.string().optional(),
  created_date: z.string().datetime().optional(),
});

const questionOption = z.object({
  id: z.number(),
  name: z.string().optional(),
  value: z.string(),
});

const questionsOptions = z.object({
  questionId: z.number(),
  telemetry_keyword: z.string(),
  answers: z.array(answerOption).optional(),
});

const questions = z.object({
  id: z.number(),
  name: z.string(),
  title: z.string(),
  category: z.string(),
  telemetry_keyword: z.string(),
  type: z.string(),
  options: z.array(questionOption),
});

const surveyDetails = z.object({
  id: z.number(),
  title: z.string(),
  description: z.string(),
  questions: z.array(questions),
});

const surveys = z.array(surveyDetails);

const surveyResponse = z.object({
  surveyId: z.number(),
  userId: z.number(),
  questions: z.array(questionsOptions),
});

const updateSurveyParams = z.object({
  userId: z.string(),
  surveyId: z.number(),
  questions: z.array(
    z
      .object({
        questionId: z.number(),
        answers: z.string(),
      })
      .optional()
  ),
});

export type UpdateSurveyParams = z.infer<typeof updateSurveyParams>;

export async function fetchOnboardingSurvey() {
  const { data } = await http().get(
    `${window.env.API_PROFILE}/surveys?title=Cisco U. EA Onboarding`
  );

  return surveys.parse(data);
}

export async function fetchOnboardingSurveyResponse() {
  const { data } = await http().get(
    `${window.env.API_PROFILE}/surveyresponse?title=Cisco U. EA Onboarding`
  );
  return surveyResponse.parse(data);
}

export function updateSurveyResponse(postObject: UpdateSurveyParams) {
  return http().post(`${window.env.API_PROFILE}/surveyresponse`, postObject);
}

export async function deleteResponse(surveyId: number) {
  await http().delete(`${window.env.API_PROFILE}/deleteSurvey/${surveyId}`);
}

export async function getSurveyQuestions(
  contentGuid: string,
  qualtricsSurveyId: number
) {
  const { data } = await http().get(
    `${window.env.API_PROFILE}/survey-questions`,
    {
      params: {
        content_guid: contentGuid,
        qualtrics_survey_id: qualtricsSurveyId,
      },
    }
  );

  return data;
}

export function assignUserToSurvey(
  userId: number,
  contentId: string,
  surveyId: number
) {
  const postObject = {
    user_id: userId,
    content_id: contentId,
    survey_id: surveyId,
    status: "assigned",
  };

  return http().post(
    `${window.env.API_PROFILE}/user-content-surveys`,
    postObject
  );
}

export async function fetchUserSurveyHistory(
  user_id: number,
  content_id: string
) {
  const { data } = await http().get(
    `${window.env.API_PROFILE}/user-content-surveys`,
    {
      params: {
        user_id,
        content_id,
      },
    }
  );
  return data;
}

export async function fetchSurveyProvider(id: number) {
  const { data } = await http().get(
    `${window.env.API_PROFILE}/survey-provider/${id}`
  );
  return data;
}
